import styled from 'styled-components'
import Icon24, { Icon20 } from 'builder/components/Icon'
import CloseIcon from './CloseIcon'
import ExpandIcon from './ExpandIcon'
import AiCoachIcon from './AiCoach'
import SendIcon from './SendIcon'
import AssistantIcon from './AssistantIcon.svg'
import LoadingIcon from './LoadingIcon'
import LinkArrow from './LinkArrow'
import ArrowUpIcon from './ArrowUp.svg'
import ArrowRight from './ArrowRight.svg'
import CopyIcon from './Copy'
import ThumbsUpIcon from './ThumbsUp'
import ThumbsDownIcon from './ThumbsDown'
import ThumbsUpFilledIcon from './ThumbsUpFilled'
import ThumbsDownFilledIcon from './ThumbsDownFilled'
import RefreshIcon from './Refresh'

export const ArrowDown = styled(Icon20.ArrowLeft)`
  transform: rotate(-90deg);
`

export const Icon = {
  Close: CloseIcon,
  Expand: ExpandIcon,
  AiCoach: AiCoachIcon,
  Send: SendIcon,
  Loading: LoadingIcon,
  ArrowDown: ArrowDown,
  ArrowUp: (props: React.ComponentProps<'img'>) => <img src={ArrowUpIcon} alt="Send" {...props} />,
  ArrowRight: (props: React.ComponentProps<'img'>) => (
    <img src={ArrowRight} alt="Send" {...props} />
  ),
  CircleError: Icon24.CircleError,
  LinkArrow: LinkArrow,
  Assistant: (props: React.ComponentProps<'img'>) => (
    <img src={AssistantIcon} alt="Assistant" {...props} />
  ),
  Copy: CopyIcon,
  ThumbsUp: ThumbsUpIcon,
  ThumbsDown: ThumbsDownIcon,
  ThumbsUpFilled: ThumbsUpFilledIcon,
  ThumbsDownFilled: ThumbsDownFilledIcon,
  Refresh: RefreshIcon,
}
